import React from 'react'
import PropTypes from 'prop-types'
import StickyHeader from 'components/StickyHeader'
import StickyHeaderWrapper from 'components/common/StickyHeaderWrapper'
import { MAIN_CONTENT, FOOTER } from 'constant'

const OneColumnProductPage = ({ placeholders: { footer, header, mainTireContent }}) =>
  <div>
    <StickyHeaderWrapper>
      { header }
      <StickyHeader />
    </StickyHeaderWrapper>
    <main id={ MAIN_CONTENT } tabIndex="-1" data-max-width data-max-width-padding>
      { mainTireContent }
    </main>
    <div id={ FOOTER }>
      { footer }
    </div>
  </div>

OneColumnProductPage.propTypes = {
  placeholders: PropTypes.shape({
    footer: PropTypes.array,
    header: PropTypes.array,
    mainTireContent: PropTypes.array
  })
}

OneColumnProductPage.type = 'OneColumnProductPage'
OneColumnProductPage.placeholders = ['footer', 'header', 'mainTireContent']

export default OneColumnProductPage
